import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { getUserRole, isAdminOrManagerRole } from 'entities/User';
import { useNavigationBlock } from 'features/NavigationBlockModal/ui/NavigationBlockProvider/NavigationBlockProvider';
import { getRouteSettingsOrdersDelivery } from 'shared/const/router';
import { Tooltip } from 'shared/ui/Tooltip';

interface TooltipProps {
    propertyId: string;
}

export default function ({ propertyId }: TooltipProps) {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { validateNavBlock } = useNavigationBlock();

    const currentUserRole = useSelector(getUserRole);

    const canDeliverySettings = isAdminOrManagerRole(currentUserRole);

    const handleSettingsClick = () => {
        validateNavBlock(
            () =>
                navigate(
                    getRouteSettingsOrdersDelivery(propertyId, 'operations'),
                ),
            true,
        );
    };

    return (
        <Tooltip
            isSecondaryColor
            interactive
            content={
                <>
                    <Typography variant="caption">
                        {t(
                            `For property deliveries, add the appropriate contact details ` +
                                `and instructions to ensure smooth deliveries to the correct location.`,
                        )}
                    </Typography>
                    {canDeliverySettings && (
                        <Typography variant="caption" sx={{ mt: '16px' }}>
                            {t(`Edit defaults in `)}
                            <Typography
                                variant="caption"
                                component="span"
                                color="primary"
                                onClick={handleSettingsClick}
                                sx={{
                                    cursor: 'pointer',
                                    textDecoration: 'underline',
                                }}
                            >
                                {t('Settings')}
                            </Typography>
                            .
                        </Typography>
                    )}
                </>
            }
        />
    );
}
